import dayjs from "dayjs";

import { Model, UIRadio, UISelect, UITable } from "@alphascriptsolutions/client-core";
import { updateAnchorChildren } from "../anchorChildManage";
import { useSharePricePerformanceStore } from "../../state/sharePricePerformanceStore";

export function addNewAnchor({
  fileName,
  anchorName,
  model,
  modelIndex,
  AnchorFirstClear = true,
  AnchorLimit = 1,
  callbackForNewModel = undefined,
  manipulateNewModel = undefined,
  panelIndex = 0,
  setModels,
  datasource = {},
}) {
  Model.getYaml(fileName)
    .then((ymlFile) => {
      if (panelIndex) ymlFile = ymlFile.replaceAll("_num_", panelIndex + "");
      else ymlFile = ymlFile.replaceAll("_num_", "");
      return new Model(ymlFile, datasource);
    })
    .then((newIndexModel) => {
      if (manipulateNewModel) newIndexModel = manipulateNewModel(newIndexModel);
      const children = updateAnchorChildren(model, anchorName, newIndexModel, {
        firstClear: AnchorFirstClear,
        limit: AnchorLimit,
      });

      if (callbackForNewModel) callbackForNewModel(newIndexModel);

      if (children) {
        model.setAtAnchor(anchorName, children);
      }

      setModels((prev) => {
        const newModels = [...prev];
        newModels.splice(modelIndex, 1, model);
        return newModels;
      });
    });
}

export function setRangeInputDate(model, rangeInputName) {
  const ranges = model.uiComponents[0].getByPartialName(rangeInputName);
  if (!ranges) return;
  ranges.map((range) => {
    const { timePeriod } = useSharePricePerformanceStore.getState();
    if (range && timePeriod && timePeriod.length > 1) {
      const startDate = dayjs(timePeriod[0]);
      const endDate = dayjs(timePeriod[1]);

      range.disabledDateRange = (current: dayjs.Dayjs) =>
        current && (current.isBefore(startDate) || current.isAfter(endDate));
    }
  });
}

export function isEmptyObject(value) {
  if (value == null) {
    return false;
  }

  if (typeof value !== "object") {
    return false;
  }

  const proto = Object.getPrototypeOf(value);

  if (proto !== null && proto !== Object.prototype) {
    return false;
  }

  return isEmpty(value);
}

function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return true;
}

export function setTableDataWithRemove<T extends { id?: number | string; hiddenId?: string }>(
  table: UITable,
  data: T[],
  onRemove: (id: T["id"] | T["hiddenId"]) => void
) {
  table.setDatasource([...data]);
  const removeCol = table.columns.find((c) => c.name === "removeCompany");
  if (removeCol) {
    removeCol.onClick = (id: any) => {
      onRemove(id);
    };
  }
}
export function setTableDataWithDropdown<T extends { id?: number | string; hiddenId?: string }>(
  table: UITable,
  data: T[],
  onChange: (newValue, id: T["id"] | T["hiddenId"]) => void
) {
  table.setDatasource([...data]);
  const removeCol = table.columns.find((c) => c.name === "DataType");
  if (removeCol) {
    removeCol.onChange = (newValue, id: any) => {
      onChange(newValue, id);
    };
  }
}

export function updateUIOptions(components: (UIRadio | UISelect)[] | undefined, options: string[]) {
  if (!components) return;
  components.forEach((component) => {
    if (!component) return;
    component.options = options;
  });
}

export function updateModelAt(index: number, getModel: () => Model[]) {
  const { setModels } = useSharePricePerformanceStore.getState();

  setModels((prev) => {
    const updated = [...prev];
    updated[index] = getModel()[index];
    return updated;
  });
}
